module.exports = __webpack_public_path__ + "assets/2c73751263ab651222dfbe1d34872859.png";